import { ColorValue, TextStyle } from "react-native";
import { AppTheme } from "../theme";

export function getTextStyles(theme: AppTheme) {
    const { fonts } = theme;
    const { body5 } = theme.textStyles;
    let typeDefaults = {
        ...body5,
        color: theme.color.text as ColorValue,
        fontWeight: "normal",
    } as TextStyle;

    let monospace = {
        ...typeDefaults,
        fontFamily: "SpaceMono-Regular",
    };

    return {
        blockQuote: {
            marginLeft: 10,
            opacity: 0.8,
        },
        codeBlock: {
            ...monospace,
        },
        del: {
            textDecorationLine: "line-through",
        },
        em: {
            fontFamily: fonts.bodyItalic,
        },
        headlineEm: {
            fontFamily: fonts.headingBoldItalic,
        },
        heading: {
            fontWeight: "700",
        },
        heading1: {
            ...typeDefaults,
            fontSize: 32,
            lineHeight: 32,
            marginTop: 22,
            marginBottom: 22,
            marginLeft: 0,
            marginRight: 0,
        },
        heading2: {
            ...typeDefaults,
            fontSize: 24,
            lineHeight: 24,
            marginTop: 20,
            marginBottom: 20,
            marginLeft: 0,
            marginRight: 0,
        },
        heading3: {
            ...typeDefaults,
            fontSize: 20,
            lineHeight: 20,
            marginTop: 20,
            marginBottom: 20,
            marginLeft: 0,
            marginRight: 0,
        },
        heading4: {
            ...typeDefaults,
            fontSize: 16,
            marginTop: 22,
            marginBottom: 22,
            marginLeft: 0,
            marginRight: 0,
        },
        heading5: {
            ...typeDefaults,
            fontSize: 14,
            marginTop: 22,
            marginBottom: 22,
            marginLeft: 0,
            marginRight: 0,
        },
        heading6: {
            ...typeDefaults,
            fontSize: 11,
            marginTop: 24,
            marginBottom: 24,
            marginLeft: 0,
            marginRight: 0,
        },
        hr: {
            backgroundColor: "white",
            height: 1,
        },
        imageWrapper: {
            padding: 4,
            width: 320,
            height: 320,
        },
        image: {
            flexGrow: 1,
        },
        inlineCode: {
            ...monospace,
        },
        link: {
            color: theme.color.link,
        },
        list: {
            margin: 8,
            // minWidth: "100%",
        },
        listItem: {
            flexDirection: "row",
            alignItems: "flex-start",
        },
        listItemNumber: {
            ...typeDefaults,
            minWidth: 20,
            paddingRight: 4,
        },
        listItemBullet: {
            ...typeDefaults,
            minWidth: 20,
            paddingRight: 4,
        },
        listItemOrderedContent: {
            ...typeDefaults,
        },
        listItemUnorderedContent: {
            ...typeDefaults,
        },
        paragraph: {
            ...typeDefaults,
            marginTop: 0,
            marginBottom: 20,
        },
        strong: {
            fontFamily: fonts.bodyBold,
        },
        headlineStrong: {
            fontFamily: fonts.headingExtraBold,
        },
        /**
         * this library is backed by simple markdown - which
         * interprets __this__ as an underline instead of bold.
         *
         * Instead of re-inventing the renderer - we're just going to restyle
         * the underline text to be bold, and avoid the problem.
         */
        u: {
            textDecorationLine: "none",
            fontWeight: "600",
        },
        /**
         * True underline styles where needed
         */
        underline: {
            ...typeDefaults,
            textDecorationLine: "underline",
        },
    };
}
